import { type FC, type HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  /** タグに表示する文字 */
  label: string;
  /** 淵（ボーダー）の色（CSS色値） */
  color: string;
}

/** タグコンポーネント — 左端に丸い穴があるラベル風デザイン */
export const Tag: FC<TagProps> = ({ label, color, className, style, ...rest }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 rounded-r-none rounded-l-[14px] border bg-white px-2 py-0.5 text-xs font-medium text-gray-700",
      className,
    )}
    style={{ borderColor: color, ...style }}
    {...rest}
  >
    {/* 左端の丸い穴 */}
    <span
      className="shrink-0 rounded-full border bg-white"
      style={{ borderColor: color, width: 10, height: 10 }}
      aria-hidden="true"
    />
    {label}
  </span>
);
